import React from 'react'

import { useRouter } from 'next/router'

import * as S from './styles'
import { useHero } from './useHero'
import { NhShape } from '@/assets/imgs'
import { Text, Typewriter } from '@/components'
import { Hero } from '@/service/api/home'

type HeroContainerProps = {
  /**
   * Data of Hero container
   *
   * @example
   * ```tsx
   * const data = {
   * ...
   * }
   *
   * <HeroContainer heroData={data} />
   * ```
   */
  heroData: Hero
}

export const HeroContainer: React.FC<HeroContainerProps> = ({ heroData }) => {
  const { headingWords, typewriterWords } = heroData

  const { getHeadingSize, availableWords } = useHero(typewriterWords)
  const router = useRouter()

  return (
    <S.FlexContainerHero
      direction="column"
      alignItems="flex-start"
      style={{
        height: '100vh',
        padding: 0,
        maxWidth: '1170px',
      }}
    >
      <div className="container-hero">
        <div>
          <S.TextContainer>
            {headingWords.map((text) => (
              <Text
                key={text + router.locale}
                size={getHeadingSize()}
                color="primary"
                className="heading"
              >
                {text}
              </Text>
            ))}
          </S.TextContainer>
          <Typewriter texts={availableWords} size={getHeadingSize()} />
        </div>

        <S.ImageWrapper>
          <S.NhImage
            src={NhShape}
            alt="Imagem que representa a nata house"
            width={0}
            height={0}
            priority
          />
        </S.ImageWrapper>
      </div>
    </S.FlexContainerHero>
  )
}
